// extracted by mini-css-extract-plugin
export default {"blurredBackground":"login_blurredBackground__4USC0","container":"login_container__P0FSm","form":"login_form__2L96z"};